module.exports = __webpack_public_path__ + "static/media/googleLoginIcon.1b943d72.png";